var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.0422C13.1046 14.0422 14 13.1468 14 12.0422C14 10.9377 13.1046 10.0422 12 10.0422C10.8954 10.0422 10 10.9377 10 12.0422C10 13.1468 10.8954 14.0422 12 14.0422Z",
    fill: "#8E97A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.04224C13.1046 7.04224 14 6.14681 14 5.04224C14 3.93767 13.1046 3.04224 12 3.04224C10.8954 3.04224 10 3.93767 10 5.04224C10 6.14681 10.8954 7.04224 12 7.04224Z",
    fill: "#8E97A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.0422C13.1046 21.0422 14 20.1468 14 19.0422C14 17.9377 13.1046 17.0422 12 17.0422C10.8954 17.0422 10 17.9377 10 19.0422C10 20.1468 10.8954 21.0422 12 21.0422Z",
    fill: "#8E97A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotIcon);
export default __webpack_public_path__ + "static/media/dotIcon.b1416fa01281f7b246a1cd9363231d85.svg";
export { ForwardRef as ReactComponent };